import { Game } from './game/game.js';
import { HUD } from './ui/hud.js';

const canvas = document.getElementById('game');
const ui = new HUD();
const game = new Game(canvas, ui);

// expose for debug
window.__neonRails = game;
